/**
 * The Set up Accounting stepper at the top of Settings › Accounting › Accounting
 * Basis (piece 23; T1191, decision 2535): what stock is costed at, the reporting
 * basis, and the opening balances, each a done test read from rows the plan
 * already names. 🔒 Nothing here is stored.
 */
export const ACCOUNTING_SETUP_STEPS_PATH = '/accounting/settings/setup-steps';

export const ACCOUNTING_SETUP_STEPS = ['costBasis', 'reportingBasis', 'openingBalances'] as const;
export type AccountingSetupStep = (typeof ACCOUNTING_SETUP_STEPS)[number];

/** What the server counts; every field is a read of a saved row and none is stored for the stepper. */
export interface AccountingSetupStepsView {
  /** `inventory.costBasis` carries a dated value. */
  costBasisSet: boolean;
  /** `ledger.defaultBasis` was saved; a default that was never saved counts as not set. */
  reportingBasisSet: boolean;
  /** The ledger is open: an opening entry stands, or a pull opened it with nothing to post (decision 2993); the go-live date is read from the same reference. */
  openingBalancesPosted: boolean;
}

export interface AccountingSetupStepFacts {
  done: boolean;
}

/** 🔒 Each step's done test (decision 2535); a key the answer lacks reads as not done. */
export function accountingSetupSteps(view: Partial<AccountingSetupStepsView>): Record<AccountingSetupStep, AccountingSetupStepFacts> {
  return {
    costBasis: { done: view.costBasisSet === true },
    reportingBasis: { done: view.reportingBasisSet === true },
    openingBalances: { done: view.openingBalancesPosted === true },
  };
}
